



















































































































import Vue from 'vue';
import { truncate } from 'lodash';
import { isEmptyObject } from '@/utils/helpers';
import props from './common/props';
import { Name } from '@/models/name';
import { Exhibitor } from '../../../models/exhibitor';

export default Vue.extend({
  props: {
    ...props.base,
    exhibitor: props.detail.exhibitor
  },
  created() {
    console.log(this.exhibitor);
  },
  methods: {
    truncate,
    isEmptyObject,
    checkEmpty(obj: any) {
      for (const key in obj) {
        if (obj[key] instanceof Object === true) {
          if (this.checkEmpty(obj[key]) === false) return false;
        } else {
          if (obj[key].length !== 0) return false;
        }
      }
      return true;
    },
    getExhibitorInitial(exhibitor: Exhibitor) {
      return exhibitor.name.substring(0, 1).toUpperCase();
    }
  }
});
